import { v4 as uuidv4 } from "uuid";

function chillHop() {
  return [
    {
      name: "Valimai Theme",
      artist: "U1",
      cover:
        "https://i.scdn.co/image/ab67616d0000b2733a8f5957d49cc694e8f4c196",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Valimai-Motion-Poster-Theme-MassTamilan.fm.mp3?alt=media&token=05e826a2-81c8-41e8-8456-9b7c41ac231c",
        color: ["#626142", "#065d54"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Iragai Pole",
      artist: "U1",
      cover:
        "https://play-lh.googleusercontent.com/_c_nwo4LMcoHggBeeFyNU1wyB4v2v4KN85az9r4eKN8_GENTsOKgLUkL1gn3fl6tpA=rw",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/u1-1.mp3?alt=media&token=b01940eb-c6e8-4ed3-9d17-d2828dbdfa5f",
        color: ["#9d7d56", "#0f0a06"],
      id: uuidv4(),
      active: true,
    },
    {
      name: "Ipdaiye",
      artist: "U1",
      cover:
        "https://play-lh.googleusercontent.com/_c_nwo4LMcoHggBeeFyNU1wyB4v2v4KN85az9r4eKN8_GENTsOKgLUkL1gn3fl6tpA=rw",
      audio:
        "https://masstamilan2000sdownload.info/tamil/2014/Poojai-Masstamilan.in/Ippadiye%20-%20Masstamilan.In-.mp3",
        color: ["#9d7d56", "#0f0a06"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "High on Love",
      artist: "U1",
      cover: "https://play-lh.googleusercontent.com/_c_nwo4LMcoHggBeeFyNU1wyB4v2v4KN85az9r4eKN8_GENTsOKgLUkL1gn3fl6tpA=rw",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/High-On-Love-MassTamilan.com.mp3?alt=media&token=19512af7-d922-4f10-88df-0a45a3fff25b",
      color: ["#333E3A", "	#FFD700"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Idhu varai",
      artist: "U1",
      cover: "https://play-lh.googleusercontent.com/_c_nwo4LMcoHggBeeFyNU1wyB4v2v4KN85az9r4eKN8_GENTsOKgLUkL1gn3fl6tpA=rw",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Idhu-Varai.mp3?alt=media&token=5a275e1b-2a8b-42d8-bdc3-d2415926806d",
        color: ["#9d7d56", "#0f0a06"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Adi Penne",
      artist: "Stephen Zechariah",
      cover:
        "http://a10.gaanacdn.com/images/albums/58/3952558/crop_480x480_3952558.jpg",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Adi-Penne-MassTamilan.fm.mp3?alt=media&token=77b44a1d-48e8-47f3-a23d-0f2cb93ad2ff",
      color: ["#678d91", "#ac5128"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Kanave Kanave",
      artist: "Tabbu",
      cover:
        "https://www.filmibeat.com/img/2013/02/01-david-review-01.jpg",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Kanave-Kanave-MassTamilan.com.mp3?alt=media&token=3fd2fc4c-21ad-409f-872f-fc65b2719812",
      color: ["#0f1213", "#78382e"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Dharala Prabu",
      artist: "Anirudh",
      cover:
        "https://www.thehindu.com/entertainment/movies/jwtbsy/article31060332.ece/ALTERNATES/LANDSCAPE_1200/Dharala-Prabhu-Songs",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Dharala-Prabhu-Title-Track-MassTamilan.io.mp3?alt=media&token=cebe42bf-12f9-4fca-8df0-66277abe6064",
      color: ["#314c67", "#a5c37d"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Yetho ondru Ennai",
      artist: "U1",
      cover:
        "https://play-lh.googleusercontent.com/_c_nwo4LMcoHggBeeFyNU1wyB4v2v4KN85az9r4eKN8_GENTsOKgLUkL1gn3fl6tpA=rw",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Yedho-Ondru-Ennai.mp3?alt=media&token=a1808ece-e79a-49a9-af12-92f6278dbbae",
      color: ["#876B7B", "#8FC7DF"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Mangalyam",
      artist: "STR",
      cover:
        "https://pbs.twimg.com/media/ErtIpa3U0AEB6s2.jpg",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Mangalyam-MassTamilan.fm.mp3?alt=media&token=abea2b4d-80ce-4470-b2ad-5f442fe0b063",
      color: ["#62472a", "#bebcaf"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Uyire en Uyire",
      artist: "U1",
      cover:
        "https://play-lh.googleusercontent.com/_c_nwo4LMcoHggBeeFyNU1wyB4v2v4KN85az9r4eKN8_GENTsOKgLUkL1gn3fl6tpA=rw",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Uyire.mp3?alt=media&token=1a1227fc-f93a-40f0-9f00-0d274ea8b48f",
        color: ["#9d7d56", "#0f0a06"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Agasatha",
      artist: "Santhosh Narayanan",
      cover:
        "https://www.tamil2lyrics.com/wp-content/uploads/2017/05/cuckoo-2.png",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Agasatha.mp3?alt=media&token=92d94242-733f-42ec-bcab-5a1fe6b8fa4e",
        color: ["#9d7d56", "#0f0a06"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Edho sola",
      artist: " Dharan Kumar",
      cover:
        "https://www.99images.com/photos/celebrities/shanthanu-bhagyaraj/shanthanu-bhagyaraj-best-hd-photos-download-1080p-whatsapp-dpstatus-images-hjun.jpg?v=1620748203",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Edho-Solla-MassTamilan.io.mp3?alt=media&token=dcdcc3d5-aa8b-4bf9-afa5-f8f8d2909163",
        color: ["#9d7d56", "#0f0a06"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "kadhal sadukudu",
      artist: "Deva",
      cover:
        "https://images.8tracks.com/cover/i/000/040/091/gall_big_image254200612271-3579.jpg?rect=128,0,768,768&q=98&fm=jpg&fit=max&w=320&h=320",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Kadhal-Sadugudu.mp3?alt=media&token=d10289a7-d695-4d96-b351-5c839db1137a",
      color: ["#f7f162", "#e9c9bf"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Loner",
      artist: "Ady Kriz",
      cover:
        "https://www.sociallykeeda.com/wp-content/uploads/2021/04/Loner-700x1160-700x470.jpg?v=1619774415",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Loner-MassTamilan.fm.mp3?alt=media&token=ff374720-fc5f-467a-975a-a500d573341f",
      color: ["#20354a", "#c5c5c3"],
      id: uuidv4(),
      active: false,
    },

    {
      name: "Marandhaye",
      artist: "Imman",
      cover:
        "http://a10.gaanacdn.com/images/song/31/30101731/crop_480x480_1587479599.jpg",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Marandhaye-MassTamilan.io.mp3?alt=media&token=56dd266e-8081-4a3f-a946-e68b77e19a1b",
      color: ["#501663", "#743349"],
      id: uuidv4(),
      active: false,
    },

    {
      name: "Nee Partha",
      artist: "Anirudh",
      cover:
        "https://c-cl.cdn.smule.com/rs-s39/arr/5f/cb/d271590d-817b-48fd-837e-f1d049a828fd_1024.jpg",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Nee-Partha.mp3?alt=media&token=a5f513fd-4cb8-48b2-bfa7-197b19b79736",
      color: ["#787485", "#cbbbbd"],
      id: uuidv4(),
      active: false,
    },

    {
      name: "Pogiren",
      artist: "Mugen Rao",
      cover:
        "https://c-cl.cdn.smule.com/rs-s80/arr/75/8e/9ea8c854-08ce-4f99-827c-a0caa6cd1403_1024.jpg",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Pogiren-MassTamilan.fm.mp3?alt=media&token=37db93f5-b19e-45f2-b9b3-ba4e8aafaf57",
      color: ["#bfaed2", "#561c18"],
      id: uuidv4(),
      active: false,
    },

    {
      name: "Hold me now",
      artist: "U1",
      cover:
        "https://i1.behindwoods.com/tamil-movies-cinema-news-16/images/sid-sriram-croons-for-a-single-in-harish-kalyan-and-raizas-pyaar-prema-kaadhal-photos-pictures-stills.jpg",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Hold-Me-Now-MassTamilan.com.mp3?alt=media&token=679bf1eb-82fe-44a1-8597-ecf64cf84dda",
      color: ["#a62b2d", "#da9763"],
      id: uuidv4(),
      active: false,
    },

    {
      name: "Rakita Rakita",
      artist: "Santhosh Narayanan",
      cover:
        "https://m.behindwoods.com/tamil-movies/slideshow/best-tamil-songs-released-in-july-2020/images/rakita-rakita-from-jagame-thanthiram.jpg",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Rakita-Rakita-Rakita-MassTamilan.fm.mp3?alt=media&token=34c6f6bb-ff87-41ea-bae6-7d461cf408b8",
      color: ["#f1dcb1", "#80290d"],
      id: uuidv4(),
      active: false,
    },

    {
      name: "Thappu Panitten",
      artist: "U1",
      cover:
        "https://www.exlyrics.com/wp-content/uploads/2021/07/Thappu-Pannitten-Song-Lyrics-Silambarasan-TR-Kalidas-Jayaram-Megha-Akash.jpg",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Thappu-Pannitten-MassTamilan.fm.mp3?alt=media&token=26932bf4-ee9a-42a9-a815-5220bc6e2ab1",
      color: ["#678d91", "#ac5128"],
      id: uuidv4(),
      active: false,
    },

   

    {
      name: "Thatan Thatan",
      artist: "Santhosh Narayanan",
      cover:
        "https://images.cinemaexpress.com/uploads/user/imagelibrary/2021/3/11/w600X390/KarnansthirdsongtitledDraupathiyinMuttham.jpg",
      audio:
        "https://firebasestorage.googleapis.com/v0/b/mycollege-c567e.appspot.com/o/Thattaan-Thattaan-MassTamilan.fm.mp3?alt=media&token=75255cbe-8014-4c36-8a81-fb297fe9cb75",
      color: ["#923f13", "#fdd154"],
      id: uuidv4(),
      active: false,
    },


  ];
}

export default chillHop;
